import { Task } from './task.model';

export class LegacyTask extends Task {
    legacyTask: boolean;
    borrowerId: number;
    borrowerName: string;
    canText: boolean;
    contactName: string;
    contactId: number;
    created: Date;
    createdTimestamp: Date;
    dismissable: boolean;
    action: string;
    taskObjectId: number;
    type: string;
    reason?: string | undefined;
    json?: any;
    fromEmail?: string;
    subject?: string;
    html?: string;
    expires?: Date;
}

